export default [
  'accountsAndNotes',
  'automobiles',
  'cashOnHand',
  'iras',
  'lifeInsurances',
  'other',
  'otherProperties',
  'realEstate',
  'savings',
  'stocks',
];



// WEBPACK FOOTER //
// ./src/vuex/modules/profile/resources/finances/assetKeys.js